import { render, staticRenderFns } from "./m_banner.vue?vue&type=template&id=9a42850e&scoped=true"
var script = {}
import style0 from "./m_banner.vue?vue&type=style&index=0&id=9a42850e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a42850e",
  null
  
)

export default component.exports